import { PAccordion, PHeading, PText } from "@porsche-design-system/components-react"
import { spacingFluidMd, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import type { StandardEquipmentView } from "@slfinrtl/ui-bff-routes"
import type { Dispatch, SetStateAction } from "react"
import { FormattedMessage, defineMessages } from "react-intl"
import { Grid, GridItem } from "src/components"
import { EquipmentCategory } from "../categories"

interface StandardEquipmentProps {
	openAccordions: Record<number, boolean>
	setOpenAccordions: Dispatch<SetStateAction<Record<number, boolean>>>
	view: StandardEquipmentView
}

const messages = defineMessages({
	noStandardEquipment: {
		defaultMessage: "No standard equipment could be determined for this vehicle.",
		id: "standardEquipment.noStandardEquipment",
	},
})

export const StandardEquipment = ({ openAccordions, setOpenAccordions, view }: StandardEquipmentProps) => {
	const midpoint = Math.ceil(view.categories.length / 2)

	const categoriesForFirstColumn = view.categories.slice(0, midpoint)
	const categoriesForSecondColumn = view.categories.slice(midpoint)

	return view.categories.length === 0 ? (
		<PText color="contrast-medium">
			<FormattedMessage {...messages.noStandardEquipment} />
		</PText>
	) : (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
			<GridItem size={{ base: 12, s: 6 }}>
				{categoriesForFirstColumn.map((category, index) => (
					<PAccordion
						key={index}
						compact
						onUpdate={() =>
							setOpenAccordions((prev) => ({
								...prev,
								[index]: !prev[index],
							}))
						}
						open={openAccordions[index]}
					>
						<PHeading slot="summary" tag="h2" size="sm" weight="semibold">
							{category.name}
						</PHeading>
						<EquipmentCategory key={category.name} category={category} />
					</PAccordion>
				))}
			</GridItem>
			<GridItem size={{ base: 12, s: 6 }}>
				{categoriesForSecondColumn.map((category, index) => (
					<PAccordion
						key={index}
						compact
						onUpdate={() =>
							setOpenAccordions((prev) => ({
								...prev,
								[index + midpoint]: !prev[index + midpoint],
							}))
						}
						open={openAccordions[index + midpoint]}
					>
						<PHeading slot="summary" tag="h2" size="sm" weight="semibold">
							{category.name}
						</PHeading>
						<EquipmentCategory key={category.name} category={category} />
					</PAccordion>
				))}
			</GridItem>
		</Grid>
	)
}
